// Prices and costs: every Catalog target (ADR-0047) with the price a user is
// charged next to what the clip costs us, cold and warm, from the measured or
// inferred run times in definitions/catalogs/. The same feed Core quotes from,
// so this table is the price list in force. Switches: CORE_FEATURES
// (cancel=, show_costs=) in the stack's .env, then restart core.
import { formatMinor } from "../../lib/format";
import { coldMargin, formatCost, formatWait, useCatalog } from "../../lib/catalog";

export default function AdminCatalog() {
  const catalog = useCatalog();
  if (!catalog) return <p className="a-lede">loading the catalog…</p>;
  const cur = catalog.currency;
  return (
    <>
      <div className="a-head">
        <div>
          <h1 className="a-h1">Prices</h1>
          <p className="a-lede">
            What each target is charged and what it costs us. A cold clip pays the worker&apos;s
            start and idle tail alone; a warm one only its run. Estimates marked inferred have no
            successful run of that exact target yet.
          </p>
        </div>
        <span className="a-panel__meta">
          {catalog.name || "no catalog"} · cancel {catalog.features.cancel ? "on" : "off"} · costs shown to{" "}
          {catalog.features.show_costs}
        </span>
      </div>

      <section className="a-panel">
        <div className="a-panel__head">
          <h2 className="a-panel__title">Targets</h2>
          <span className="a-panel__meta">{catalog.targets.length} targets</span>
        </div>
        <div className="a-scroll">
          <table className="a-table" data-testid="catalog-table">
            <thead>
              <tr>
                <th>Grade</th>
                <th>Size</th>
                <th className="a-table__num">Length</th>
                <th className="a-table__num">fps</th>
                <th className="a-table__num">Price</th>
                <th className="a-table__num">Cold cost</th>
                <th className="a-table__num">Warm cost</th>
                <th className="a-table__num">Cold margin</th>
                <th className="a-table__num">Cold wait</th>
                <th className="a-table__num">Run</th>
                <th>Worker</th>
                <th>Basis</th>
              </tr>
            </thead>
            <tbody>
              {catalog.targets.map((t) => {
                const e = t.estimate;
                const m = coldMargin(t);
                return (
                  <tr key={`${t.alias}/${t.seconds}/${t.fps}`} title={[e.note, e.profile_note].filter(Boolean).join(" — ")}>
                    <td>{t.grade}</td>
                    <td>
                      {t.width}×{t.height}
                    </td>
                    <td className="a-table__num">{t.seconds} s</td>
                    <td className="a-table__num">{t.fps}</td>
                    <td className="a-table__num">{formatMinor(t.price, cur)}</td>
                    <td className="a-table__num">{e.cold_cost_minor !== undefined ? formatCost(e.cold_cost_minor, cur) : "·"}</td>
                    <td className="a-table__num">{e.warm_cost_minor !== undefined ? formatCost(e.warm_cost_minor, cur) : "·"}</td>
                    <td className="a-table__num">{m !== undefined ? `${Math.round(m * 100)} %` : "·"}</td>
                    <td className="a-table__num">{formatWait(e.cold_wait_s)}</td>
                    <td className="a-table__num">{formatWait(e.warm_wait_s)}</td>
                    <td>
                      {e.gpu}
                      {e.usd_per_hour !== undefined && ` · $${e.usd_per_hour.toFixed(2)}/h`}
                    </td>
                    <td>
                      {e.basis}
                      {e.samples > 0 && ` (${e.samples})`}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}
